import { Field } from '@/layout/fields'
import { getDateFormatPattern, getDateFormatPatternForBQL } from '@/utils'
import dayjs from 'dayjs'

export class DateField extends Field {
  getLocalizedFilterColumn (column) {
    const pattern = getDateFormatPatternForBQL(Intl.DateTimeFormat().resolvedOptions().locale)
    return `date_format(${column.key}, "${pattern}")`
  }

  getLocalizedValue (value) {
    return dayjs(value).format(getDateFormatPattern(Intl.DateTimeFormat().resolvedOptions().locale))
  }
}
